import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { ResultAlertError } from '@app/enums/errors.enum';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {PassengerService} from '@app/services/micro/passenger.service';
import {GlobalsService} from "@services/micro/globals.service";
import {Passenger} from '@app/models/micro/passenger.model';
import {Router} from "@angular/router";
@Component({
    selector: 'app-seat-benefits-modal',
    templateUrl: './seat-benefits-modal.component.html',
    styleUrls: ['./seat-benefits-modal.component.scss'],
    standalone: false
})
export class SeatBenefitsModalComponent implements OnInit {
  @Input() public titleError: string = '';
  @Input() public msgError: string = '';
  @Input() public codeError: string = '';
  @Input() public uuidError: string = '';
  @Input() public printCard: string = '';
  @Input() public backgroundColorModal: string = 'am-blue-premium';
  @Input() public showButton: boolean = true;
  @Input() public buttonCopy: string = '';
  @Input() public showIconImage: boolean = true;
  @Input() public urlIconImage: string = '';
  @Input() public colorFontButton: string = '';
  @Input() public backGroundButton: string = '';
  @Input() public sizeModal: string = '';
  @Input() public fontWeightTitleError: string = '';
  @Input() public image: string = '';
  @Input() public showCancelButton = false;
  @Input() public cancelButtonText ='';
  @Input() public notPaxVen = true;
  @Input() public fareName ='';
  passengerSelected: Passenger[]
  currentPassenger: Passenger;
  passengers: Array<Passenger> = [];

  infoClass = SEAT_INFO[''];

  constructor(
    private modalService: NgbActiveModal,
    private _passengerService: PassengerService,
    private global: GlobalsService,
    private router: Router,
    public modal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    console.log(this.fareName)
    this.infoClass = SEAT_INFO[this.fareName];
    console.log(this.infoClass)
  }

  close(){
    this.modal.close();
  }
}

export enum SeatType {
  FIRST_CLASS = 'FIRST_CLASS',
  AM_PLUS = 'AM_PLUS',
  PREFERRED = 'PREFERRED',
  EXIT_ROW = 'EXIT_ROW',
  COACH = 'COACH',
}

export interface SeatInfo {
  title: string;
  subtitle2: string;
  bullets: string[];
  theme: 'purple' | 'teal'  | 'indigo' | 'green' | 'sand';
  imageUrl: string;
  imageIcon: string;
  imgListIcon: string[];
}

export const SEAT_INFO: Record<SeatType, SeatInfo> = {
  [SeatType.FIRST_CLASS]: {
    title: 'Premier cabin',
    subtitle2: 'Elevated space and comfort',
    bullets: [
      'Seat at the front of the Main Cabin',
      'Priority baggage handling',
      'Complimentary snacks',
      'Priority deplaning',
      '2 pieces of checked baggage',
    ],
    imgListIcon: [
      'assets/images/cama-mb.svg',
      'assets/images/estrella-mb.svg',
      'assets/images/cubierto-mb.svg',
      'assets/images/diamante-mb.svg',
      'assets/images/maletas-mb.svg',
    ],
    theme: 'purple',
    imageUrl: 'assets/images/premier-cabin.png',
    imageIcon: 'assets/images/legend-premier.svg',
  },
  [SeatType.PREFERRED]: {
    title: 'Preferential seat',
    subtitle2: 'Personalize your flight',
    bullets: [
      'Standard seat',
      'Priority deplaning',
      'Priority seat placement',
    ],
    theme: 'teal',
    imageUrl: 'assets/images/preferential.png',
    imageIcon: 'assets/images/legend-preferred.svg',
    imgListIcon: [
      'assets/images/paloma-mb.svg',
      'assets/images/escalera-mb.svg',
      'assets/images/diamante-mb.svg',
    ]
  },
  [SeatType.COACH]: {
    title: 'Regular seat',
    subtitle2: 'Travel lightly',
    bullets: [
      'Standard seat selection',
      'Secure your seat',
    ],
    theme: 'sand',
    imageUrl: 'assets/images/regular.png',
    imageIcon: 'assets/images/legend-standard.svg',
    imgListIcon: [
      'assets/images/paloma-mb.svg',
      'assets/images/peso-mb.svg',
    ]
  },
  [SeatType.AM_PLUS]: {
    title: 'AM Plus seat',
    subtitle2: 'Comfort and convenience',
    bullets: [
      'AM Plus seat',
      'Priority baggage handling',
      'Priority deplaning',
      'Exclusive overhead bin storage',
    ],
    theme: 'indigo',
    imageUrl: 'assets/images/am-plus.png',
    imageIcon: 'assets/images/legend-am-plus.svg',
    imgListIcon: [
      'assets/images/asiento-am-mb.svg',
      'assets/images/estrella-mb.svg',
      'assets/images/diamante-mb.svg',
      'assets/images/maletas-am-mb.svg',
    ]
  },
  [SeatType.EXIT_ROW]: {
    title: 'Emergency Exit seat',
    subtitle2: 'More legroom',
    bullets: [
      'Selection next to the emergency exit',
      'Standard seat',
      'More space between seats',
    ],
    theme: 'green',
    imageUrl: 'assets/images/exit.png',
    imageIcon: 'assets/images/legend-emergency-exit.svg',
    imgListIcon: [
      'assets/images/Emergency-Exit-mb.svg',
      'assets/images/paloma-mb.svg',
      'assets/images/dos-asientos-mb.svg',
    ]
  },
};
